import React from 'react';
import { TextInput, TextArea, SectionHeader } from './Fields';

const FooterEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });

  return (
    <div>
      <SectionHeader title="Rodapé" />
      <TextArea label="Descrição" value={data.description} onChange={v => set('description', v)} rows={3} />
      <TextInput label="Email" value={data.email} onChange={v => set('email', v)} placeholder="contato@exemplo.com" />
      <TextInput label="Telefone" value={data.phone} onChange={v => set('phone', v)} placeholder="(86) 99999-9999" />
      <TextInput label="Localização" value={data.location} onChange={v => set('location', v)} placeholder="Teresina, Piauí" />
    </div>
  );
};

export default FooterEditor;
